var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditDisable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8308 10.4803L13.5197 7.16916M4 20L6.80156 19.6887C7.14385 19.6507 7.31499 19.6317 7.47496 19.5799C7.61688 19.5339 7.75194 19.469 7.87647 19.3869C8.01684 19.2943 8.1386 19.1726 8.38212 18.9291L19.3142 7.99696C20.2286 7.0826 20.2286 5.60013 19.3142 4.68577C18.3999 3.77141 16.9174 3.77141 16.0031 4.68577L5.07094 15.6179C4.82742 15.8614 4.70566 15.9832 4.6131 16.1235C4.53097 16.2481 4.46606 16.3831 4.42012 16.525C4.36833 16.685 4.34932 16.8561 4.31128 17.1984L4 20Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.65559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDisable);
export default __webpack_public_path__ + "static/media/edit-disable.de9eda23.svg";
export { ForwardRef as ReactComponent };